var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import PacketArticle from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        /*delete(id: number) {
          // console.log('delete')
          return api.delete('packets/' + id).then(this.splice)
        }*/
        this.set = function (values) {
            _this.data = values.map(function (item) { return new PacketArticle(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            _this.data.push(new PacketArticle(value));
        };
        this.replace = function (value) {
            // console.log('replace - value', value)
            // console.log(this.data)
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
        };
        this.splice = function (value) {
            // console.log('splice - value', value)
            // console.log(this.data)
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value; }), 1);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('Packetes/Store - read')
        if (id)
            return api.get("packetarticles/".concat(id, "?eager=[prices, tax, stretches]"));
        return api.get('packets?eager=[prices, tax, stretches]')
            // .then(this.set)
            .then(function (value) {
            // console.log('Packetes/Store - read - get - value', value)
            return _this.set(value);
            // return value
        });
    };
    default_1.prototype.create = function (value) {
        // console.log('create', value)
        return api.post('packetarticles', value).then(this.push);
    };
    default_1.prototype.update = function (id, value) {
        // console.log('update', value)
        return api.put('packetarticles/' + id, value).then(this.replace);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('packetarticles/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "splice", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/PacketArticles/Store.ts
// module id = 716
// module chunks = 0